"use client";

export default function RootLoading() {
  return null; // Or return your small spinner if you want it for other routes
}